module.exports = __webpack_public_path__ + "assets/70d042eb092762152d03db3552977f2e.png";